import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { DataTableColumn } from "../../datatable/datatablecolumn/datatablecolumn.component";

@Component({
    standalone: false,
    templateUrl: "./table.component.html",
})
export class FormlyTable extends FieldType<FieldTypeConfig> {
    constructor() {
        super();
    }

    ngOnInit() {
        if (!this.field.props) this.field.props = {};

        if (!this.field.props.scrollable)
            this.field.props.scrollable = true;
    }

    change($event) {
        if (this.props.change) this.props.change(this);
    }

    getFilter(column: DataTableColumn): boolean {
        if (column.filter == null) return true;
        return column.filter;
    }

    onRowChanged(row): void {
        if (this.props.onRowChanged) this.props.onRowChanged(row);
    }
}
